export default "__VITE_ASSET__17682233__"